export default __webpack_public_path__ + "fffd18b6fbb73963142193e339af569e.svg";